import { useState} from "react";
import { hasTransferPermission, getUser } from "./constants/Requests";
import { useNavigate } from "react-router-dom";


import { getSessionToken, deleteUserAndTokenInStorage } from './helpers/AuthHelper/AuthHelperV2';


function createId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

const expireDays = 14;

const Login = () => {
  
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  
  const handleSubmit = async (e) => {

    e.preventDefault();

    setHasError(false);
    setError("");

    try{
      let r = await getSessionToken(username, password);

      if(!r.resultLogin){
        setHasError(true);
        setError("Incorrect username or password");
        return;
      }

      const user = await getUser();
      var isRepublicaUser = user.email.endsWith("@republica.dk");
      if(isRepublicaUser){
        window.location.reload();
        return;
      }

      var hasTransferPermision = await hasTransferPermission();
      if(!hasTransferPermision)
      {
        deleteUserAndTokenInStorage();
        setHasError(true);
        setError("You cannot access this page, please contact mbsupport@republica.dk");
        return;
      }
      window.location.reload();

    }
    catch(e){
      deleteUserAndTokenInStorage();
      setHasError(true);
      setError(JSON.stringify(e));
      navigate("/");
    }
    finally{
      setLoggingIn(false);
    }
  };



  return (

    <div className="transfer-rt-body"
      style={{
        backgroundImage: 'url("/assets/background.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}>

      <img src="assets/RepublicaTransfer-logo.png" class="republica-logo"/>

      <div/>

      <div className="transfer-rt-page">
        <header className="transfer-rt-header">
          <div className="transfer-rt-brand">
          </div>
        </header>

        <main className="transfer-rt-content">
          <section className="transfer-rt-cards">     
       
            <div className="transfer-rt-card">
              <h2>Username</h2>

              <form id="transfer-rt-transfer-form" onSubmit={handleSubmit}>
                <div className="transfer-rt-form-group">
                  <input
                  disabled={loggingIn}
                    id="transfer-rt-email-input"
                    type="text"
                    className="transfer-rt-form-input"
                    placeholder="Username*"
                    required
                    onChange={(e) =>  setUsername(e.target.value)}
                    value={username}
                  />
                </div>

                <div className="transfer-rt-form-group transfer-rt-form-name-group">
                  <h2 className="transfer-rt-form-label" htmlFor="transfer-rt-shipment-name">
                    Password
                  </h2>
                  <input
                  disabled={loggingIn}
                    id="transfer-rt-shipment-name"
                    type="password"
                    className="transfer-rt-form-input"
                    placeholder="Password*"
                    onChange={(e) => setPassword(e.target.value) }
                     value={password}
                    required
                  />
                </div>

                <button
                  className="transfer-rt-btn-primary"
                  type="submit"
                  id="transfer-rt-send-btn"
                >
                  Log in
                </button>
                {hasError && <div>{error}</div>}
              </form>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Login;